export class BaseGrammar {

    public static readonly $inject: string[] = [];

    constructor() { }

    /**
     * @description 判断是否为空
     * undefind和null一律视为空，空字符串为非空
     * @param target 
     */
    public isEmpty(target: any): boolean {
        // TODO 功能待实现
        return !!!target
    }

}